import React from 'react';
import PropTypes from 'prop-types';
import useWhitelabel from '@goeuro/app/client/b2b-components/src/hooks/use-whitelabel';

import Section from 'components/section';

const addExtraFields = (section, config) => ({
  ...section,
  config: {
    ...section.config,
    ...config,
  },
});

const prepareSections = (sections, title, translations) =>
  sections.map(section => {
    if (section.type === 'hero')
      return addExtraFields(section, { title, translations });
    if (section.type === 'ferret')
      return addExtraFields(section, { translations });

    return section;
  });

const HomePage = ({ translations }) => {
  const { wlData } = useWhitelabel();

  const preparedSections = prepareSections(
    wlData.sections,
    wlData.headline,
    translations
  );

  return (
    <React.Fragment>
      {preparedSections.map(section => (
        <Section
          key={section.id}
          type={section.type}
          theme={section.theme}
          config={section.config}
        />
      ))}
    </React.Fragment>
  );
};

HomePage.propTypes = {
  translations: PropTypes.objectOf(PropTypes.string),
};

export default HomePage;
